<template lang="pug">
#articles
  .page-controls
    b-field(grouped)
      b-field(expanded)
        b-input
      p.control
        button.button.is-success(
          :class="{ 'is-loading': settings.submitting }"
          @click="newArticle"
        )
          b-icon(icon="plus")
          span New Article
  spinner(v-if="settings.loading")
  div(v-else)
    b-table(
      :data="articles"
      :hoverable="true"
      :backend-pagination="true"
      :total="pagination.total"
      :current-page="pagination.page"
      :per-page="pagination.per"
      @click="redirect"
      @page-change="getPage"
      paginated
    )
      template(slot-scope="props")
        b-table-column(label="Title") {{ props.row.title }}
        b-table-column(label="Publish Date")
          small(v-if="props.row.pub_date") {{ props.row.pub_date | date }}
          small.has-text-grey-light(v-else) NA
        b-table-column(label="Author")
          small(v-if="props.row._embedded.author.id") {{ props.row._embedded.author.full_name }}
          small.has-text-grey-light(v-else) NA
</template>

<script>
import { mapGetters } from 'vuex';
import Spinner from '@/components/Spinner';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';

export default {
  name: 'articles',
  components: {
    Spinner,
  },
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
      articles: getters.GET_ARTICLES,
    }),
    esQuery() {
      const from = this.pagination.per * (this.pagination.page - 1);
      const payload = {
        from,
        size: this.pagination.per,
        sort: [
          { pub_date: 'desc' },
          { created_at: 'desc' },
        ],
        query: {
          bool: {
            must: [
              { match: { account_id: this.account.id } },
            ],
          },
        },
      };
      return payload;
    },
  },
  created() {
    this.getPage(1);
  },
  data() {
    return {
      pagination: {
        page: 1,
        per: 26,
        total: 0,
      },
      settings: {
        loading: false,
        submitting: false,
      },
    };
  },
  methods: {
    async getPage(page) {
      this.settings.loading = true;
      this.pagination.page = page;
      const response = await this.$store.dispatch(actions.DO_SEARCH_ARTICLES, this.esQuery);
      this.pagination.total = response.hits.total;
      this.settings.loading = false;
    },
    async newArticle() {
      this.settings.submitting = true;
      const { data } = await this.$store.dispatch(actions.DO_CREATE_ARTICLE, {});
      this.settings.submitting = false;
      this.redirect(data.articles[0]);
    },
    redirect(article) {
      this.$router.push({ name: 'article', params: { id: article.id } });
    },
  },
};
</script>

<style lang="scss">
.b-table {
  table {
    tr {
      td {
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Articles.vue